const CentroDeCustosHome = () =>
  import(/* webpackChunkName: "group-pabx-cadastros-centrodecusto" */ '../_views/CentroDeCustosHome')
const CadastroCentroDeCustos = () =>
  import(/* webpackChunkName: "group-pabx-cadastros-centrodecusto" */ '../_views/CadastroCentroDeCustos')
const AtualizarCentroDeCustos = () =>
  import(/* webpackChunkName: "group-pabx-cadastros-centrodecusto" */ '../_views/AtualizarCentroDeCustos')

import { permissionsPabx } from '../../../../../utils/permissionsPabx'

export default [
  {
    path: 'centrodecustos',
    component: CentroDeCustosHome,
    meta: { requiresAuth: true, permissions: [...permissionsPabx] },
    name: 'Centrodecustos',
  },
  {
    path: 'centrodecustos/criar',
    component: CadastroCentroDeCustos,
    meta: { requiresAuth: true, permissions: [...permissionsPabx] },
    name: 'Centrodecustos/criar',
  },
  {
    path: 'centrodecustos/atualizar/:_id',
    component: AtualizarCentroDeCustos,
    meta: { requiresAuth: true, permissions: [...permissionsPabx] },
    name: 'centrodecustos/atualizar',
    props: true,
  },
]
